"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _dom = _interopRequireDefault(require("@spothero/utils/dom"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Loader = _interopRequireDefault(require("../Loader/Loader"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

// import {
//     SelectItemPropTypes,
//     OptgroupPropTypes
// } from './SelectItemPropTypes';
var Select =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Select, _Component);

  function Select() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Select)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      validationState: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onInvalid", function (evt) {
      evt.preventDefault();
      var onInvalid = _this.props.onInvalid;
      var validationState = evt.currentTarget.validity;

      _this.setState({
        validationState: validationState
      });

      if (onInvalid) {
        onInvalid(validationState);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onChange", function (evt) {
      var _this$props = _this.props,
          items = _this$props.items,
          onChange = _this$props.onChange;
      var selectedItem = items.reduce(function (options, _ref) {
        var optgroup = _ref.optgroup,
            item = (0, _objectWithoutProperties2.default)(_ref, ["optgroup"]);
        return optgroup ? (0, _toConsumableArray2.default)(options).concat((0, _toConsumableArray2.default)(optgroup)) : (0, _toConsumableArray2.default)(options).concat([item]);
      }, []).find(function (_ref2) {
        var value = _ref2.value;
        return value === evt.target.value;
      });

      _this.setState({
        validationState: null
      });

      if (onChange) {
        onChange(selectedItem);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_renderOptgroup", function (_ref3) {
      var label = _ref3.label,
          optgroup = _ref3.optgroup;
      return _react.default.createElement("optgroup", {
        key: label,
        label: label
      }, optgroup.map(_this._renderItem));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_renderItem", function (_ref4, i) {
      var _ref4$disabled = _ref4.disabled,
          disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
          _ref4$label = _ref4.label,
          label = _ref4$label === void 0 ? '' : _ref4$label,
          _ref4$value = _ref4.value,
          value = _ref4$value === void 0 ? '' : _ref4$value;
      return _react.default.createElement("option", {
        key: i,
        value: value,
        disabled: disabled
      }, label);
    });
    return _this;
  }

  (0, _createClass2.default)(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._select.addEventListener('invalid', this._onInvalid);

      this._checkIfDisabledSelected();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      this._checkIfDisabledSelected();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._select.removeEventListener('invalid', this._onInvalid);
    }
  }, {
    key: "_checkIfDisabledSelected",
    value: function _checkIfDisabledSelected() {
      // if a disabled option is selected at first, make it the same color as placeholder as thats typically why its selected
      if ((0, _isEmpty.default)(this._select.value)) {
        _dom.default.addClass(this._select, 'FormElement-item-placeholder');
      } else {
        _dom.default.removeClass(this._select, 'FormElement-item-placeholder');
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          name = _this$props2.name,
          items = _this$props2.items,
          disabled = _this$props2.disabled,
          loading = _this$props2.loading,
          error = _this$props2.error,
          helpNode = _this$props2.helpNode,
          label = _this$props2.label,
          icon = _this$props2.icon,
          required = _this$props2.required,
          inline = _this$props2.inline,
          defaultValue = _this$props2.defaultValue,
          placeholder = _this$props2.placeholder,
          onFocus = _this$props2.onFocus;
      var validationState = this.state.validationState;
      var isValid = validationState ? validationState.valid : true;
      var containerClasses = (0, _classnames.default)('Select', 'FormElement', {
        'FormElement-inline': inline
      }, {
        'FormElement-with-icon': icon
      }, {
        'FormElement-contains-error': !isValid
      }, className);
      var newDefaultValue = placeholder && !defaultValue ? '' : defaultValue;
      return _react.default.createElement("div", {
        className: containerClasses
      }, label, _react.default.createElement("div", {
        className: "FormElement-control"
      }, _react.default.createElement("select", {
        ref: function ref(node) {
          _this2._select = node;
        },
        className: "FormElement-item",
        name: name,
        required: required,
        disabled: disabled,
        defaultValue: newDefaultValue,
        onFocus: onFocus,
        onChange: this._onChange
      }, placeholder && _react.default.createElement("option", {
        value: "",
        disabled: true
      }, placeholder), items.map(function (item, i) {
        return item.optgroup ? _this2._renderOptgroup(item) : _this2._renderItem(item, i);
      })), !loading && _react.default.createElement(_Icon.default, {
        className: "Select-dropdown-icon",
        name: "chevron-down",
        size: 10
      }), loading && _react.default.createElement(_Loader.default, {
        size: 16,
        borderWidth: 2
      }), _react.default.createElement("span", {
        className: "Select-icon"
      }, icon)), helpNode && _react.default.createElement("div", {
        className: "FormElement-help-text"
      }, helpNode), !isValid && error);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: "node",

    /**
     * Getter for the select DOM element.
     *
     * @public
     * @returns {Element} - The select element.
     */
    get: function get() {
      return this._select;
    }
  }]);
  return Select;
}(_react.Component);

exports.default = Select;
(0, _defineProperty2.default)(Select, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** A unique name which is used to identify this element. If belonging to a form this is used as the key for serialization and is required. */
  name: _propTypes.default.string,

  /** A custom label (typically a Label component) to display above the select. */
  label: _propTypes.default.element,

  /** Adds an initial, unselectable item to display in the dropdown. */
  placeholder: _propTypes.default.string,

  /** Whether this field is required during validation. */
  required: _propTypes.default.bool,

  /** Disallows user interaction. */
  disabled: _propTypes.default.bool,

  /** Whether to show a loading animation inside of the component. */
  loading: _propTypes.default.bool,

  /** An array of options or an array of option groups */
  items: _propTypes.default.array.isRequired,
  // items: PropTypes.oneOfType([
  //     PropTypes.arrayOf(PropTypes.shape(SelectItemPropTypes)),
  //     PropTypes.arrayOf(PropTypes.shape(OptgroupPropTypes))
  // ]).isRequired,

  /** A custom help element to place below the select. */
  helpNode: _propTypes.default.node,

  /** Applies proper styling to display this field inline in a form. */
  inline: _propTypes.default.bool,

  /** A custom icon (typically an Icon component) to show in the select field. */
  icon: _propTypes.default.element,

  /** The default value to display in the select when mounted. */
  defaultValue: _propTypes.default.string,

  /** A custom validation error (typically a FormElementError component) to display when this component is part of a form and is invalid. */
  error: _propTypes.default.element,

  /**
   * Function to execute when the select changes.
   *
   * @param {Object} item - The value/label pair of the selection.
   */
  onChange: _propTypes.default.func,

  /**
   * Function to execute when the select is focused.
   *
   * @param {SyntheticEvent} evt - The React `SyntheticEvent`.
   */
  onFocus: _propTypes.default.func,

  /**
   * Function to execute when the element is marked as invalid by a validation check.
   *
   * @param {ValidityState} validationState - ValidityState object for more fine grained control over error handling in a parent component if desired.
   */
  onInvalid: _propTypes.default.func
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Select, "Select", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Select/Select.jsx");
  leaveModule(module);
})();

;